import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.isTicking = false;
        this.onViewportChange = this.onViewportChange.bind(this);

        window.addEventListener("scroll", this.onViewportChange, { passive: true });
        window.addEventListener("resize", this.onViewportChange);
        this.updateVisibility();
    }

    disconnect() {
        window.removeEventListener("scroll", this.onViewportChange);
        window.removeEventListener("resize", this.onViewportChange);
    }

    onViewportChange() {
        if (this.isTicking) {
            return;
        }

        this.isTicking = true;
        window.requestAnimationFrame(() => {
            this.updateVisibility();
            this.isTicking = false;
        });
    }

    updateVisibility() {
        const isVisible = window.scrollY > (window.innerHeight * 0.95);

        this.element.classList.toggle("back-to-top--visible", isVisible);
        this.element.inert = !isVisible;

        if (!isVisible && document.activeElement === this.element) {
            this.element.blur();
        }
    }

    scrollToTop() {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        window.scrollTo({
            top: 0,
            behavior: prefersReducedMotion ? "auto" : "smooth"
        });
    }
}
